export default __webpack_public_path__ + "static/media/june.a3041496.jpg";